import React, { useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
// eslint-disable-next-line import/no-extraneous-dependencies
import { MdDelete } from 'react-icons/md'
import { Formik, Form as FormikForm } from 'formik'
import { useDispatch, useSelector } from 'react-redux'
import * as reducks from '../../../../reducks'
import useWalletFilters from '../useWalletFilters'
import Text from '../../Text/Text'
import Flex from '../../Flex/Flex'
import SelectFieldFormik from '../../Fields/SelectFieldFormik'
import Button from '../../Button/Button'
import Modal from '../../Modal/Modal'

/**
 * @TODO Itens a fazer ainda
 * @FIXME add use callback on handlers button
 */

export const handleClear = async (valuesRef, resetFormRef, defaultRef = {}) => {
  if (!resetFormRef) return

  const newValues = {}

  Object.keys(valuesRef).forEach((field) => {
    newValues[field] = defaultRef[field] || []
  })

  resetFormRef({ values: newValues })
}

export const handleSubmit = async (data, closeCallback, dispatch) => {
  await dispatch(reducks.resources.wallet.actions.walletApplyFilters(data))
  closeCallback()
}

export const extractFilters = (filters) => ({
  networkCodes: filters.networkCodes,
  subsidiaryCodes: filters.subsidiaryCodes,
  partnerStdCodes: filters.partnerStdCodes
})

const ModalFilters = ({ filters, visible, closeCallback }) => {
  let resetFormRef
  let valuesRef

  const dispatch = useDispatch()

  const { canViewPartner, canViewNetwork, canViewSubsidiary } =
    useWalletFilters()

  useEffect(() => {
    if (canViewPartner)
      dispatch(reducks.resources.filters.actions.getPartners())

    if (canViewNetwork)
      dispatch(reducks.resources.filters.actions.getNetworks())

    if (canViewSubsidiary)
      dispatch(reducks.resources.filters.actions.getSubsidiary())
  }, [])

  const { networkCodes, subsidiaryCodes, partnerStdCodes } = useSelector(
    (state) => state.filtersReducer
  )

  const initialValues = useMemo(() => extractFilters(filters), [])

  useEffect(() => {
    resetFormRef({
      values: extractFilters(filters)
    })
  }, [visible])

  return (
    <Modal
      visible={visible}
      size="small"
      rounded
      onClickOverlay={closeCallback}
      HeaderContent={() => (
        <>
          <Text value="Filtros" size="md" color="gray" variation="dark" bold />
          <button
            type="button"
            onClick={() => {
              return handleClear(
                valuesRef,
                resetFormRef,
                reducks.resources.wallet.INITIAL_STATE.filters
              )
            }}
          >
            <Text
              value="Limpar"
              color="gray"
              variation="dark"
              size="xxs"
              margin="0px 5px 0px 0px"
            />
            <MdDelete color="#4D4D4D" size={15} />
          </button>
        </>
      )}
    >
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={(data) => handleSubmit(data, closeCallback, dispatch)}
      >
        {({ isSubmitting, isValid, values, resetForm }) => {
          const disabled = isSubmitting || !isValid

          resetFormRef = resetForm
          valuesRef = values

          return (
            <FormikForm>
              <>
                {canViewNetwork && (
                  <Flex column margin="24px 0px">
                    <Flex alignItems="center" justifyContent="space-between">
                      <Text
                        value="Rede"
                        size="sm"
                        color="gray"
                        variation="dark"
                        font="custom"
                        bold
                      />

                      <Text
                        value="Limpar"
                        size="xxs"
                        color="gray"
                        variation="dark"
                        font="custom"
                        onClick={() => {
                          return resetForm({
                            values: { ...values, networkCodes: [] }
                          })
                        }}
                        underline
                      />
                    </Flex>

                    <SelectFieldFormik
                      name="networkCodes"
                      placeholder="Selecione a Rede"
                      options={networkCodes.content}
                    />
                  </Flex>
                )}

                {canViewSubsidiary && (
                  <Flex column margin="24px 0px">
                    <Flex alignItems="center" justifyContent="space-between">
                      <Text
                        value="Regional"
                        size="sm"
                        color="gray"
                        variation="dark"
                        font="custom"
                        bold
                      />

                      <Text
                        value="Limpar"
                        size="xxs"
                        color="gray"
                        variation="dark"
                        font="custom"
                        onClick={() => {
                          return resetForm({
                            values: { ...values, subsidiaryCodes: [] }
                          })
                        }}
                        underline
                      />
                    </Flex>

                    <SelectFieldFormik
                      name="subsidiaryCodes"
                      placeholder="Selecione a Regional"
                      options={subsidiaryCodes.content}
                    />
                  </Flex>
                )}

                {canViewPartner && (
                  <Flex column margin="24px 0px">
                    <Flex alignItems="center" justifyContent="space-between">
                      <Text
                        value="Nome do consultor ou subconsultor"
                        size="sm"
                        color="gray"
                        variation="dark"
                        font="custom"
                        bold
                      />

                      <Text
                        value="Limpar"
                        size="xxs"
                        color="gray"
                        variation="dark"
                        font="custom"
                        onClick={() => {
                          return resetForm({
                            values: { ...values, partnerStdCodes: [] }
                          })
                        }}
                        underline
                      />
                    </Flex>

                    <SelectFieldFormik
                      name="partnerStdCodes"
                      placeholder="Selecione o nome do consultor ou subconsultor"
                      options={partnerStdCodes.content}
                    />
                  </Flex>
                )}

                <Flex
                  alignItems="center"
                  justifyContent="center"
                  margin="30px 0px"
                >
                  <Button
                    width="234px"
                    type="secondary"
                    buttonType="submit"
                    disabled={disabled}
                  >
                    Ver Resultado
                  </Button>
                </Flex>
              </>
            </FormikForm>
          )
        }}
      </Formik>
    </Modal>
  )
}

ModalFilters.defaultProps = {
  visible: true
}

ModalFilters.propTypes = {
  visible: PropTypes.bool,
  closeCallback: PropTypes.func.isRequired,
  filters: PropTypes.shape({
    storeStatus: PropTypes.array,
    storeGroups: PropTypes.array,
    products: PropTypes.array,
    networkCodes: PropTypes.array,
    subsidiaryCodes: PropTypes.array,
    partnerStdCodes: PropTypes.array,
    priorityMatrices: PropTypes.array,
    segments: PropTypes.array,
    subsegments: PropTypes.array,
    orderBy: undefined
  }).isRequired
}

export default ModalFilters
